export * from './environment';

export const surveyCod: { [key: string]: number } = {
  personasFeedBack: 34897,
};
